const FooterCategoryData = [
  {
    categoryHeader: "Services",
    categoryList: [
      { name: "WebstaurantPlus", link: "/plus/" },
      { name: "Webstaurant Rewards", link: "/rewards/" },
      { name: "WebstaurantStore App", link: "/services/app/" },
      {
        name: "Customize Your Supplies",
        link: "/customizable-restaurant-supplies.html",
      },
      { name: "Recipe Resizer", link: "/recipe_resizer.html" },
      { name: "Partners & Integrations", link: "/services/partners/" },
    ],
  },
  {
    categoryHeader: "Resources",
    categoryList: [
      { name: "Blog", link: "/blog/" },
      { name: "Scratch & Dent Outlet", link: "/outlet.html" },
      { name: "Weekly Sales", link: "/specials.html" },
      { name: "Coupons", link: "/blog/2150/monthly-coupon-code-update.html" },
      { name: "Food Service Resources", link: "/food-service-resources.html" },
      {
        name: "WebstaurantStore Reviews",
        link: "/blog/1772/webstaurantstore-reviews.html",
      },
      {
        name: "Safety Recall",
        link: "https://www.lancastertableandseating.com/recalls/",
      },
    ],
  },
  {
    categoryHeader: "About",
    categoryList: [
      { name: "About Us", link: "/aboutus.html" },
      { name: "Our Brands", link: "/ourbrands.html" },
      { name: "Careers", link: "/careers/" },
      { name: "Scholarship", link: "/scholarship/" },
      { name: "Sell on Webstaurant", link: "/vendor-application/" },
      { name: "Return Policy", link: "/policies.html#Returns_Policy" },
    ],
  },
];

export default FooterCategoryData;
